import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

export default function Profile() {
  const { me, refresh } = useOutletContext();
  const [name, setName] = useState(me.name || "");
  const [email, setEmail] = useState(me.email || "");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch("/auth/me", { name, email: email || null });
      toast.success("Profile saved.");
      refresh?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="space-y-7" data-testid="profile-page">
      <div>
        <span className="label-overline text-jow-gold">Profile</span>
        <h2 className="font-display text-3xl text-jow-navy mt-1">A little about you.</h2>
      </div>

      <div className="bg-white border border-jow-navy/10 p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="label-overline text-jow-navy/70">Phone</label>
          <input
            value={me.phone}
            disabled
            className="input-jow border-b mt-2 opacity-70"
            data-testid="profile-phone"
          />
        </div>
        <div>
          <label className="label-overline text-jow-navy/70">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input-jow border-b mt-2"
            placeholder="Your name"
            data-testid="profile-name"
          />
        </div>
        <div className="md:col-span-2">
          <label className="label-overline text-jow-navy/70">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-jow border-b mt-2"
            placeholder="you@inbox.in"
            data-testid="profile-email"
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={busy}
        className="btn-primary-jow"
        data-testid="profile-save"
      >
        {busy ? "Saving…" : "Save profile"}
      </button>
    </form>
  );
}
